var _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4098,
    cy: 6.34987,
    rx: 3.22032,
    ry: 3.34987,
    fill: "#888888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 14.6953C4.10938 11.2929 6.86757 8.53467 10.27 8.53467V8.53467C13.6724 8.53467 16.4306 11.2929 16.4306 14.6953V16.3996H4.10938V14.6953Z",
    fill: "#888888"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2471,
    cy: 8.64766,
    rx: 2.00686,
    ry: 2.0876,
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3203 13.8482C12.3203 11.7279 14.0392 10.009 16.1595 10.009V10.009C18.2799 10.009 19.9987 11.7279 19.9987 13.8483V14.9104H12.3203V13.8482Z",
    fill: "#888888"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.92679,
    cy: 8.6479,
    rx: 2.00686,
    ry: 2.0876,
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.8485C0 11.7282 1.71888 10.0093 3.83922 10.0093V10.0093C5.95956 10.0093 7.67844 11.7282 7.67844 13.8485V14.9106H0V13.8485Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroups);
export default __webpack_public_path__ + "static/media/userGroups.274009d6aa1d8a8605baa9ef4e61a632.svg";
export { ForwardRef as ReactComponent };